require('jquery-lazy');
require('jquery-lazy/jquery.lazy.plugins');
import "waypoints/lib/jquery.waypoints";

const jqueryLazy = function () {

  $('.lazy').lazy({
    effect: 'fadeIn',
    // visibleOnly: true,
    onError: function (element) {
      //console.log('error loading ' + element.data('src'));
    }
  })

}

export default jqueryLazy;
